import axios from "axios";
import { handleError } from "../handleError";
import {
  Group,
  GroupType,
  Institution,
  PassGroup,
  PassLog,
  Person,
  Reservation,
  ReservationGroup,
  SpecificRule,
  Vehicle,
  Visitor
} from "../../object";
// import {LError} from '../../object'
const state = {};
const getters = {};
const mutations = {};
const actions = {
  async checkPass({ dispatch }, { plate, datetime, cId }) {
    console.log(plate, datetime, cId);
    return dispatch(
      "getDataFromApi",
      {
        url: "/pipe/pass/getAuthByObjectCode?pipe=qrcode",
        method: "post",
        data: {
          objectCode: plate,
          passTime: datetime + ":00",
          controllerId: cId
        }
      },
      { root: true }
    );
  },
  async getVehicles(
    { dispatch },
    { group, pagination, sortStack, search, filter = {}, locate = "runtime" }
  ) {
    let { items, amount } = await dispatch(
      "getDataList",
      {
        url: `/passObjectApi/object/list`,
        pagination,
        sortStack,
        search,
        filter: { ...filter, obgrpId: group.id },
        transDict: {
          plate: "objectId",
          rhdata: "RHData",
          startDatetime: "sdtime",
          endDatetime: "edtime"
        }
      },
      { root: true }
    );
    return {
      items: items,
      amount
    };
  },
  async deleteVehicle({ dispatch }, ids) {
    let url = "/passObjectApi/object/";
    try {
      let res = await axios.delete(url, {
        data: {
          ids: ids
        }
      });
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  async getPassGroupList(
    { dispatch },
    { pagination, sortStack, search, filter }
  ) {
    let { items, amount } = await dispatch(
      "getDataList",
      {
        url: "/passObjectApi/group/list/",
        pagination,
        sortStack,
        search,
        filter: { ...filter } || {},
        transDict: {
          rhdata: "RHData"
        }
      },
      { root: true }
    );
    return {
      items,
      amount
    };
  },
  async setSpecificRule({ dispatch, rootState }, rule) {
    let res = await dispatch(
      "getDataFromApi",
      {
        url: "/passObjectApi/pass/rule/controller",
        method: "put",
        data: {
          passrule: { ...rule.toAPI(), ownerId: rule.vehicle.objectId }
        }
      },
      { root: true }
    );
    let s = SpecificRule.fromAPI(res, rootState.parkingLot.controllerList);
    if (rule.isStandalone !== undefined) {
      await dispatch(
        "pass/setStandalone",
        {
          vehicle: s.vehicle,
          value: rule.isStandalone
        },
        { root: true }
      );
      s.isStandalone = rule.isStandalone;
    }
    return s;
  },
  async setPassGroup({ dispatch }, group) {
    // if (isNaN(et)) {
    //   et = time.parse(et).valueOf() + ''
    // }
    let res = await dispatch(
      "getDataFromApi",
      {
        url: "/passObjectApi/group/",
        method: "put",
        data: {
          id: "",
          name: group.name,
          description: group.description,
          priority: group.priority,
          osdMsgIn: group.ledPromptIn,
          vcbMsgIn: group.audioPromptIn,
          osdMsgOut: group.ledPromptOut,
          vcbMsgOut: group.audioPromptOut
        }
      },
      { root: true }
    );
    return ReservationGroup.fromAPI(res);
  },
  async getRegisterVehicles(
    { dispatch },
    { pagination, sortStack, search, filter = {}, locate = "runtime" }
  ) {
    let { items, amount } = await dispatch(
      "getDataList",
      {
        url: `/passObjectApi/check/list`,
        pagination,
        sortStack,
        search,
        filter: { ...filter },
        transDict: {
          plate: "plateNumber"
        }
      },
      { root: true }
    );
    let vehicles = [];
    for (let i = 0; i < items.length; i++) {
      let vehicle = items[i];
      vehicle.plateNumber = vehicle.vehicle.plateNumber;
      vehicle.phone = vehicle.user.mobilePhone;
      vehicle.name = vehicle.user.name;
      vehicles.push(vehicle);
    }
    return {
      items: vehicles,
      amount
    };
  },
  async addVehicle({ dispatch }, params) {
    let url = "/passObjectApi/object/";
    try {
      let res = await axios.put(url, params);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  async getGroups({ dispatch }, { pagination, filter, search, sortStack }) {
    let { items, amount } = await dispatch(
      "getDataList",
      {
        url: "/passObjectApi/group/info/all/runtime",
        pagination,
        filter: filter,
        search,
        sortStack
      },
      { root: true }
    );
    return { items: items.map(item => PassGroup.fromAPI(item)), amount };
  },
  async getLogs(
    { dispatch, rootState },
    { pagination, filter, sortStack, search }
  ) {
    let { items, amount } = await dispatch(
      "getDataList",
      {
        url: "/passObjectApi/pass/log/list",
        pagination,
        filter,
        sortStack,
        search,
        transDict: {
          plate: "objectId",
          passDatetime: "passTimeController",
          details: "remark"
        }
      },
      { root: true }
    );

    const res = {
      items: items.map(item =>
        PassLog.fromAPI(item, rootState.parkingLot.personControllerList)
      ),
      amount
    };
    console.log("1", res);
    return res;
  },
  getPassStatisticsSummary({ dispatch }, request) {
    return dispatch("getDataFromApi", {
      method: "post",
      url: "/passObjectApi/pass/log/statistics/summary",
      data: request
    }, { root: true });
  },
  getPassStatisticsVehicles({ dispatch }, { request, pagination }) {
    return dispatch("getDataFromApi", {
      method: "post",
      url: "/passObjectApi/pass/log/statistics/vehicles",
      data: request,
      params: { page: pagination.page - 1, size: pagination.rowsPerPage }
    }, { root: true });
  },
  async searchVehicles({ dispatch }, { plate }) {
    let res = await dispatch(
      "getDataFromApi",
      {
        method: "post",
        url: `/passObjectApi/object/info/${plate}/origin`
      },
      { root: true }
    );
    // 预约车辆
    if (res.orders && res.orders.length) {
      let info = res.orders[0];
      let v = new Vehicle({
        plate: info.order.visitorObjectCode,
        owner: Visitor.fromAPI(info.visitor),
        vehicleType: Vehicle.RESERVATION
      });
      return { items: [v], amount: 1 };
    }
    // 登记车辆
    if (res.vehicle) {
      let user = {};
      try {
        user = Person.fromAPI(res.user.userInfo);
        user.institution = Institution.fromAPI(res.user.selfConfig.currentInst);
        let org = Group.fromAPI(res.user.selfConfig.currentOrg);
        org.typeList.push(new GroupType({ name: "org" }));
        user.groupList = [org];
      } catch (e) {
        console.error(e);
      }

      let v = new Vehicle({
        plate: res.vehicle.plateNumber,
        vehicleType: res.vehicle.checkType,
        owner: user
      });
      // console.log('v', v)
      return { items: [v], amount: 1 };
    }
    return { items: [], amount: 0 };
  }
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
